import React from 'react'
import { Redirect } from 'react-router-dom'

import store from '../../store/Store'
import actions from '../../actions/Actions'
import routes from '../../routes/Routes'

import AddBoxOutlinedIcon from '@material-ui/icons/AddBoxOutlined'

import Icon from "@material-ui/core/Icon"
import IconButton from '@material-ui/core/IconButton'

import './editorOverviewItem.scss'

type editorOverviewItemState = {
	article: any;
	history: any;
	imageIndex: any;
}

type editorOverviewItemProps = {
	article: any;
	history: any;
	imageIndex: any;
}

class EditorOverviewItem extends React.Component<editorOverviewItemState, editorOverviewItemProps> {

  constructor(props) {
  	super(props)

  	// console.log(props)

  	this.state = {
  		article: props.article,
  		history: props.history,
  		imageIndex: props.imageIndex
  	}
  }

  componentDidMount() {
  	// console.log('EditorOverviewItem Did Mount')

	store.subscribe(() => {
		this.setState({
			article: store.getState().article
		})
	})
  }

  componentWillUnmount() {
  	// console.log('EditorOverviewItem Will Unmount')

	store.subscribe(() => {
		this.setState({
			article: store.getState().article
		})
	})
  } 

  editArticle = () => {
  	this.redirect(routes.ROUTE_ARTICLE)
  }

  	redirect = (route) => {
		const { history } = this.state

		actions.routeActions.changeRoute({
			route
		})

		history.push(route)
	}

  render() {
  	  const {
  	  	article,
  	  	imageIndex
  	  } = this.state

  	  // console.log(imageIndex)

	  return (
	  	<div
	  		className="EditorOverviewItem"
	  		style={{
	  			display: 'inline-block',
	  			width: 'calc(100% - 60px)',
	  			height: 'calc(100% - 30px)',
	  			padding: 0,
	  			margin: '0 0 30px 60px'
	  		}}
	  	>
  			
	  		<table
	  			style={{
	  				width: '100%',
	  				height: '100%',
	  				borderSpacing: 0,
	  				border: 'none',
	  				cursor: 'pointer',
	  				padding: 0,
	  				margin: 0
	  			}}
	  			onClick={ this.editArticle.bind(this) }
	  		>
	  			<thead
	  				style={{
  						width: '100%',
  						height: '100%',
  						padding: 0,
	  					margin: 0
  					}}
	  			>
	  				<tr
	  					style={{
	  						padding: 0,
	  						margin: 0
	  					}}
	  				>
	  					<th
	  						style={{
		  						width: '110px',
		  						padding: 0,
	  							margin: 0
		  					}}
	  					>
	  						<img 
	  							style={{
	  								width: '110px',
	  								height: '300px',
	  								padding: 0,
	  								margin: 0
	  							}}
	  							src={ '/images/' + imageIndex + '_Editor.png' }
	  						/>
	  					</th>
	  					<th
	  						style={{
		  						width: '100%',
		  						padding: 0,
	  							margin: 0
		  					}}
	  					>
	  						<img 
	  							style={{
	  								width: '100%',
	  								height: '300px',
	  								borderLeft: '1px solid rgba(0, 0, 0, 255)',
	  								padding: 0,
	  								margin: 0
	  							}}
	  							src={ '/images/background.jpg' }
	  						/>
	  					</th>
	  				</tr>
	  			</thead>

	  			<tbody
	  				style={{
  						width: '100%',
  						height: '40px',
  						maxHeight: '40px',
  						padding: 0,
	  					margin: 0
  					}}
	  			>
	  				<tr
	  					style={{
	  						padding: 0,
	  						margin: 0
	  					}}
	  				>
	  					<td
	  						style={{
		  						padding: 0,
		  						margin: 0
		  					}}
	  						colSpan={ 2 }
	  					>
	  						<div
	  							style={{
		  							width: 'calc(100% - 120px)',
		  							padding: 0,
		  							margin: '0 0 0 120px',
		  							color: 'rgba(31, 87, 121, 255)',
		  							fontSize: '32px'
		  						}}
	  						>
	  							LOREM IPSUM DOLOR SIT AMET. LOREM...
	  						</div>
	  					</td>
	  				</tr>
	  			</tbody>
	  		</table>

		</div>
	  );
	}
}

export default EditorOverviewItem;